import { render, staticRenderFns } from "./NavbarLinkMobile.vue?vue&type=template&id=127cea14&"
import script from "./NavbarLinkMobile.vue?vue&type=script&lang=js&"
export * from "./NavbarLinkMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports